(function () {
  'use strict';

  /* @ngdoc object
   * @name user.registration
   * @description
   *
   */
  angular
  .module('neo.authentication.registration', [
    'ui.router',
    'ngMaterial'
  ]);
}());
